import { FormControl, FormHelperText, MenuItem, Select, Typography } from '@mui/material';
import React from 'react';
import { Formik } from '@/types';
import { TurmaModel } from '@/features/list-turma/types';
import { useTurmas } from '@/features/list-turma/api/getTurma.ts';

type ListTurmaProps = {
  formik: Formik | any;
  name: string;
  required?: boolean;
  serieId: string | number;
}

const ListTurma: React.FC<ListTurmaProps> = ({ formik, name, required = true, serieId }) => {

  const { data } = useTurmas(serieId);
  const error = required && formik.touched[name] && formik.errors[name];

  return (
    <FormControl sx={{ '.MuiSvgIcon-root': { color: 'rgba(68, 68, 68, 1)' } }} fullWidth error={error}>
      <Typography mb={'7px'}>Turma*</Typography>
      <Select
        id={name}
        name={name}
        required
        sx={{ color: '#000', border: '1px solid #000' }}
        value={formik.values[name]}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched[name] && !!formik.errors[name]}
      >
        <MenuItem key={''} value={null}>{''}</MenuItem>
        {
          data?.map((item: TurmaModel) => <MenuItem
            key={String(item.id)}
            value={item.sigla}>{`${item.sigla}`}</MenuItem>)
        }
      </Select>
      {
        formik.touched[name] &&
        formik.errors[name] &&
        <FormHelperText>{formik.errors[name]}</FormHelperText>
      }
    </FormControl>
  );
};

export default ListTurma;